import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

function AlmostDoneModal({ show, close, text }) {
  return (
    <Modal isOpen={show} toggle={close} modalClassName="help-dialog">
      <div className="semicircle-button-container">
        <div className="semicircle-button done" onClick={close}>
          {"×"}
        </div>
      </div>
      <ModalBody>
        <div className="text primary">{text.almostDone}</div>

        <div className="text">{text.filledIn}</div>
      </ModalBody>
      <ModalFooter className="modal-footer-container">
        <Button color="primary" size="lg" block={true} onClick={close}>
          {text.continue}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

AlmostDoneModal.propTypes = {
  close: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  text: PropTypes.object.isRequired,
};

export default AlmostDoneModal;



// WEBPACK FOOTER //
// ./src/components/AlmostDoneModal.js